/** API route map: URLS.Controller.ClientCategory */
export const ClientCategory = {
      Name: 'ClientCategory/',
      GetClientCategories: 'get-client-categories',
      AddClientCategory: 'add-client-category',
      UpdateClientCategory: 'update-client-category',
      DeleteClientCategory: 'delete-client-category',
};
